var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaAproximacin1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#331e51;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-aproximaci\xF3n_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.14,108.69l-5.53,12.1-3.45,7.55h42.43V100.58H176.76A13.9,13.9,0,0,0,164.14,108.69ZM192.26,123h-28.8L169,110.91a8.53,8.53,0,0,1,7.77-5h15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,128.34l-3.44-7.55-5.53-12.1a13.9,13.9,0,0,0-12.62-8.11H24.76v27.76H67.19ZM30.1,105.91H45.6a8.54,8.54,0,0,1,7.77,5L58.9,123H30.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,92.78V86.61H170.62a19.32,19.32,0,0,0-17.34,10.82L139,126.67a15.27,15.27,0,0,0-1.55,6.66v19.19A11.49,11.49,0,0,0,148.89,164h5.66c0,.25,0,.51,0,.76a14.85,14.85,0,1,0,29.69,0c0-.25,0-.51,0-.76h27.1v-6.22H182.47a14.84,14.84,0,0,0-26.19,0h-7.39a5.26,5.26,0,0,1-5.25-5.26V133.33a9,9,0,0,1,.9-3.92l14.33-29.24a13.08,13.08,0,0,1,11.75-7.33h34.46ZM159.9,164a9.51,9.51,0,0,1,18.95,0c0,.25,0,.5,0,.76a9.52,9.52,0,0,1-19,0C159.86,164.5,159.88,164.25,159.9,164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,119.41,77,114.31,65.65,96.06A20.8,20.8,0,0,0,48,86.27H15.72v6.22H48a14.59,14.59,0,0,1,12.38,6.86l12.75,20.46,25.16,5.67a12.16,12.16,0,0,1,9.49,11.87v19.2a1.22,1.22,0,0,1-1.22,1.23H85.36a14.83,14.83,0,0,0-26.18,0H15.72V162a2,2,0,0,0,2,2h39.7c0,.25,0,.51,0,.76a14.84,14.84,0,1,0,29.68,0c0-.25,0-.51,0-.76h19.46a7.44,7.44,0,0,0,7.44-7.45v-19.2a18.36,18.36,0,0,0-14.34-17.94ZM72.27,174.27a9.51,9.51,0,0,1-9.51-9.51c0-.26,0-.51,0-.76a9.51,9.51,0,0,1,19,0c0,.25,0,.5,0,.76A9.51,9.51,0,0,1,72.27,174.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.09,100.58H91.58a10.31,10.31,0,0,1-8.92-15.46l23.25-40.27h0a10.31,10.31,0,0,1,17.85,0L147,85.12a10.31,10.31,0,0,1-8.92,15.46Zm-23.25-53a2.37,2.37,0,0,0-2.11,1.21h0L89.47,89.06a2.44,2.44,0,0,0,2.11,3.65h46.51a2.44,2.44,0,0,0,2.11-3.65L117,48.78A2.39,2.39,0,0,0,114.84,47.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.18,81.76a3.25,3.25,0,0,1-2.34,5.6,3.24,3.24,0,0,1-2.35-.9,3.16,3.16,0,0,1-.91-2.36,3.15,3.15,0,0,1,3.26-3.26A3.13,3.13,0,0,1,117.18,81.76Zm.67-21.88a.4.4,0,0,1,.13.31V78.66a.44.44,0,0,1-.45.45h-5.32a.44.44,0,0,1-.32-.13.46.46,0,0,1-.13-.32V60.19a.44.44,0,0,1,.13-.31.45.45,0,0,1,.32-.14h5.32A.43.43,0,0,1,117.85,59.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaAproximacin1);
export default __webpack_public_path__ + "static/media/ic-alerta-aproximación_1.f7f65dcc7a19bd9e1e00509d5e3eb0c1.svg";
export { ForwardRef as ReactComponent };